module.exports = __webpack_public_path__ + "img/couples-007.3d47a010.jpg";